<template>
  <div>
    <div class="mt-goods-top">
      <div class="mt-goods-img">
        <img :src="imgServer+'logo.png'" alt="" />
      </div>
      <div class="mt-goods-single" style="margin-top: 15px;">
        <div class="mt-goods-name">{ {{detailInfo.deliveryType == 1 ? '自提订单' : '配送订单'}}} -- {{orderStatusTxt}}</div>
        <div class="mt-goods-id">订单号：{{detailInfo.orderNo}}</div>
      </div>
      <div class="mt-goods-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="物流1" name="orderInfo">
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 退货商品
              </div>
              <div class="mt-order-table">
                <el-table
                    :data="detailInfo.refundGoodsPageVoList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="thumb"
                      label="商品图片"
                      width="180">
                      <template slot-scope="scope">
                        <el-image
                          style="width: 40px;"
                          :src="scope.row.thumb"
                          :preview-src-list="[scope.row.thumb]"
                          fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="goodsName"
                      label="商品名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="specName"
                      label="商品规格">
                    </el-table-column>
                    <el-table-column
                      prop="refundNumber"
                      label="商品数量">
                    </el-table-column>
                  </el-table>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 物流信息
              </div>
              <div class="mt-order-wl">
                <div class="mt-order-wl-num">
                  {{detailInfo.sendCompany}}：{{detailInfo.sendNumber}}
                </div>
                <div style="padding-left: 8px;box-sizing: border-box;">
                  <div v-for="(item,index) in detailInfo.logisticsInfoList" :key="index" class="mt-order-wl-box">
                    <img v-if="index == 0" class="mt-order-wl-icon" :src="imgServer+'wl_icon.png'" alt="" />
                    <div v-if="index != 0" class="mt-order-wl-circle"></div>
                    <div v-if="index == 0" class="mt-order-wl-title">{{detailInfo.logisticsStatusDesc}}</div>
                    <div class="mt-order-wl-txt">{{item.desc}}</div>
                    <div class="mt-order-wl-time">{{item.time}}</div>
                  </div>
                  <!-- <div class="mt-order-wl-box">
                    <div class="mt-order-wl-circle"></div>
                    <div class="mt-order-wl-txt">[石家庄市] 快件已在 [长安三部] 签收，签收人：本人，感谢使用顺丰快递，期待下次为您服务!</div>
                    <div class="mt-order-wl-time">2020-09-22  10:00:00</div>
                  </div>
                  <div class="mt-order-wl-box">
                    <div class="mt-order-wl-circle"></div>
                    <div class="mt-order-wl-txt">[石家庄市] 快件已在 [长安三部] 签收，签收人：本人，感谢使用顺丰快递，期待下次为您服务!</div>
                    <div class="mt-order-wl-time">2020-09-22  10:00:00</div>
                  </div> -->
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchRefundLogisticsById } from '@/api/afterSale'
export default {
  name: 'AfterSaleWl',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'orderInfo',
      detailInfo: {
        deliveryType:'',
        thumb: '',
        orderStatus: '',
        orderNo: '',
        sendNumber: '',
        refundGoodsPageVoList:[],
        logisticsInfoList:[],
        logisticsStatusDesc:''
      },
      orderStatusTxt:''
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {},
    detailInfoFun(){
      var that = this;
      fetchRefundLogisticsById({id:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          var orderStatusTxt = '';
          switch (data.refundStatus) {
            case 0:
              orderStatusTxt = '退款待审核';
              break;
            case 1:
              orderStatusTxt = '退款已通过';
              break;
            case 2:
              orderStatusTxt = '退款已驳回';
              break;
          }
          that.orderStatusTxt = orderStatusTxt;
          that.detailInfo = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/AfterSaleWl.vue